import { useEffect, useState } from "react";
import { useForm } from 'react-hook-form'

import Modal from '../Modal';
import { bulkCreateSubtask } from "../../api/tasks.api";
import { showSuccess, showError } from "../../services/toastServices";
import { CategoryData } from "../../pages/Category/CategoryWrapper";

export function BulkSubtaskModal({ task, closeAction }) {
    const { register, handleSubmit, formState: { errors }, setValue, control } = useForm();
    const[subtasks, setSubtasks] = useState([])
    const {category, refreshProjectsCategory} = CategoryData();

    const handleClose = () => {
        closeAction()
    };

    const actionBar = (
        <div className="flex">
            <button className=' bg-blue-400 rounded-md block w-10 hover:bg-blue-500' onClick={handleClose}>X</button>
        </div>
    )
    const renderHeader = () => {
        if(task){
            return(<h1 className='font-bold text-2xl'>{task.name} - Inserta una lista de subtareas</h1>)
        }
    }
    

    const handleSave = handleSubmit(async data => {
        if(task && task.id){
            const subtasks = data.subtasksList.split(';')
            const subtasksObj = []
            
            subtasks.map(subtask=>(
                subtasksObj.push(
                    subtask.trim()
                )
            ))
            const payload = {
                subtaskNames: subtasksObj
            }
            await bulkCreateSubtask(task.id, payload, createSubtaskSuccess, createSubtaskError)
        }
    })

    const createSubtaskSuccess = (res => {
        showSuccess('Subtareas creada')
        refreshProjectsCategory(category)
        handleClose()
    })

    const createSubtaskError = (error => {
        showError(`Error al crear la subtareas. ${error.message}. ${error.response.data}`)
    })

    const renderButton = () => {
        return(<button className='bg-blue-400 p-3 rounded-lg block w-full hover:bg-blue-500' onClick={handleSave}>Crear</button>)
    }

    const modal = <Modal onClose={handleClose} actionBar={actionBar} header={renderHeader} modalSize={'52'}>
        <div className='mt-3 grid grid-cols-3 '>
            <div className='col-span-3 ml-2'>
                <form action="" >
                    <div>Lista de nombre de subtareas separados por ';'. Se admiten un total de 15 nombres</div>
                   <textarea
                        rows="3"
                        placeholder="Subtareas"
                        {...register("subtasksList", { required: false })}
                        className=' bg-blue-100 p-3 rounded-lg block w-full mb-3'
                    />
                    {errors.subtasksList && <span>Campo requerido</span>}
                </form>

                {renderButton()}
            </div>
        </div>
    </Modal>

    return (
        <div>
            {modal}
        </div>
    )
}